import { BundleGenderPreference, BundlePlan, SlotsEnum } from "../../enums/common";

export default class PatchUserBundleMetaDto {
    plan!: BundlePlan;
    genderPreference!: BundleGenderPreference;
    totalPeople!: number;
    slots!: SlotsEnum;
    utensils!: boolean;
    visitsPerDay!: number;
}